import { render, staticRenderFns } from "./LanguagesSelector.vue?vue&type=template&id=3769f271&scoped=true"
import script from "./LanguagesSelector.vue?vue&type=script&lang=js"
export * from "./LanguagesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769f271",
  null
  
)

export default component.exports